import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../appUtils/axiosConfig";

const filters = {
  categoryId: "",
  sort: "",
  contentType: "",
  text: "",
};

const initialState = {
  isLoading: false,
  error: null,
  productslist: [],
  totalPages: 0,
  page: 0,
  totalProducts: 0,
  limit: 10,
  currentPage: 0,

  productCategoryList: [],
  productInventoryList: [],
  productInventory: null,
  isInventoryLoading: false,
  product: null,
  productbanner: null,
  Filters: filters,
  cart: [],
  cartLoading: false,
  carterror: null,
  wishlist: [],
  wishlistLoading: false,
  wishlisterror: null,
  cartCount: 0,
  wishlistCount: 0,
};

export const getAllProducts = createAsyncThunk(
  "products/get_products",
  async (
    {
      categoryid,
      page,
      limit,
      price,
      discount,
      review,
      search,
      append = false,
    },
    { dispatch, getState, rejectWithValue },
  ) => {
    try {
      dispatch(getallproductsStart());
      const response = await axios.get(
        `products/get_active_products.php?category_id=${categoryid || ""}&page=${page || 1}&limit=${limit || 10}&sort=${price || ""}&discount=${discount||null}&review=${review||null}&search=${search || ""}&pincode=${localStorage.getItem("delivery_pincode") || ""}`,
      );
      dispatch(getallproductsSuccess({ ...response?.data, append }));
      return { ...response?.data, append };
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || "Failed to load products";
      dispatch(getallproductsfailure(msg));
      return rejectWithValue(msg);
    }
  },
);
export const getRelatedProducts = createAsyncThunk(
  "products/get_related_products",
  async ({ category_id, product_id }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `products/get_related_products.php?category_id=${category_id || ""}&product_id=${product_id || ""}`,
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || "Failed to load related products");
    }
  },
);

export const getSingleProduct = createAsyncThunk(
  "product/singleproduct",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    try {
      dispatch(getsingleproductStart());
      const slug = typeof payload === "string" ? payload : payload?.slug;
      const pincode = typeof payload === "object" ? payload?.pincode : null;
      const pinParam = pincode ? `&pincode=${encodeURIComponent(pincode)}` : "";
      const response = await axios.get(
        `products/get_productwithslug.php?slug=${slug}${pinParam}`,
      );
      dispatch(getsingleproductSuccess(response?.data));
      return response?.data;
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || "Failed to load product";
      dispatch(getsingleproductfailure(msg));
      return rejectWithValue(msg);
    }
  },
);

export const getProductBanner = createAsyncThunk(
  "config/get_productbanner",
  async (_, { dispatch, getState, rejectWithValue }) => {
    try {
      dispatch(getproductbannerStart());
      const response = await axios.get(`config/get_productbanner`);
      dispatch(getproductbannerSuccess(response?.data));
      return response?.data;
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || "Failed to load banner";
      dispatch(getproductbannerfailure(msg));
      return rejectWithValue(msg);
    }
  },
);

export const getProductCategory = createAsyncThunk(
  "product/getProductCategory",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getallproductCategoryStart());
      const response = await axios.get(`product/productcategory_all`);
      dispatch(
        getallproductCategorySuccess(response?.data?.allproductcategories),
      );
      return response?.data?.allproductcategories;
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || "Failed to load category";
      dispatch(getallproductCategoryfailure(msg));
      return rejectWithValue(msg);
    }
  },
);
export const getProductInventory = createAsyncThunk(
  "inventories/get_inventory_for_product",
  async ({ product_id, weight, qty, pincode }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getallproductInventoryStart());
      const pin =
        pincode ||
        localStorage.getItem("delivery_pincode") ||
        localStorage.getItem("user_pincode") ||
        "";
      const pinParam = pin ? `&pincode=${encodeURIComponent(pin)}` : "";
      const response = await axios.get(
        `inventories/get_inventory_for_product.php?product_id=${product_id}&weight=${weight || ""}&qty=${qty || 1}${pinParam}`,
      );
      dispatch(getallproductInventorySuccess(response?.data));
      return response?.data;
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || "Failed to load inventory";
      dispatch(getallproductInventoryfailure(msg));
      return rejectWithValue(msg);
    }
  },
);
export const getInventoryById = createAsyncThunk(
  "inventories/get_inventory_by_id",
  async ({ inventory_id, qty, pincode }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getproductInventoryStart());
      const pin =
        pincode ||
        localStorage.getItem("delivery_pincode") ||
        localStorage.getItem("user_pincode") ||
        "";
      const pinParam = pin ? `&pincode=${encodeURIComponent(pin)}` : "";
      const response = await axios.get(
        `inventories/get_inventory_by_id.php?inventory_id=${inventory_id}&qty=${qty}${pinParam}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      );
      if (response?.data?.status === "success") {
        dispatch(getproductInventorySuccess(response?.data));
      }
      return response?.data;
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || "Failed to load inventory";
      dispatch(getproductInventoryfailure(msg));
      return rejectWithValue(msg);
    }
  },
);
export const getProductVariartions = createAsyncThunk(
  "variations/get_variartions_by_ids",
  async ({ productId, sizes }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "variations/get_variartions_by_ids.php",
        {
          productId,
          sizes, // should be an array like ["1","2","3"]
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || "Something went wrong",
      );
    }
  },
);

export const addTocart = createAsyncThunk(
  "cart",
  async (cartData, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(`cart/add_to_cart.php`, cartData);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || "Failed to add to cart");
    }
  },
);
export const addToWishlist = createAsyncThunk(
  "wishlist",
  async (wishlistData, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(
        `wishlist/add_to_wishlist.php`,
        wishlistData,
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || "Failed to add to wishlist");
    }
  },
);

export const getCartData = createAsyncThunk(
  "cart/get_cart",
  async (pincodeArg, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getCartDataStart());
      const pincode =
        (typeof pincodeArg === "string" ? pincodeArg : pincodeArg?.pincode) ||
        localStorage.getItem("delivery_pincode") ||
        localStorage.getItem("user_pincode") ||
        "";
      const pinParam = pincode ? `?pincode=${encodeURIComponent(pincode)}` : "";
      const response = await axios.get(`cart/get_cart.php${pinParam}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      dispatch(getCartDataSuccess(response?.data));
      return response?.data;
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || "Failed to load cart";
      dispatch(getCartDataFailure(msg));
      return rejectWithValue(msg);
    }
  },
);
export const removeCartData = createAsyncThunk(
  "cart/remove_cart",
  async ({ user_id, inventory_id, cart_id }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getCartDataStart());
      const response = await axios.post(`cart/remove_from_cart.php`, {
        user_id,
        inventory_id,
        cart_id,
      });

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || "Failed to remove item");
    }
  },
);
export const updateCartQuantity = createAsyncThunk(
  "cart/update_cart_quantity",
  async (
    { user_id, inventory_id, cart_id, quantity },
    { dispatch, rejectWithValue },
  ) => {
    try {
      const response = await axios.post(`cart/update_cart_quantity.php`, {
        user_id,
        inventory_id,
        cart_id,
        quantity,
      });

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || "Failed to update quantity");
    }
  },
);
export const getCartWishlistLength = createAsyncThunk(
  "cart/get_cart_wishlist_count",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getCartCountStart());
      const response = await axios.get(`cart/get_cart_wishlist_count.php`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      dispatch(getCartCountSuccess(response?.data));

      return response?.data;
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || "Failed to count items";
      dispatch(getCartCountFailure(msg));
      return rejectWithValue(msg);
    }
  },
);
export const getWishlistData = createAsyncThunk(
  "wishlist/get_wishlist",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(getWishlistDataStart());
      const response = await axios.get(`wishlist/get_wishlist.php`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      dispatch(getWishlistDataSuccess(response?.data));
      return response?.data;
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || "Failed to load wishlist";
      dispatch(getWishlistDataFailure(msg));
      return rejectWithValue(msg);
    }
  },
);
const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    getallproductsStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    getallproductsSuccess(state, action) {
      state.isLoading = false;
      const { data, pagination, append } = action.payload;
      if (append) {
        state.productslist = [...(state.productslist || []), ...(data || [])];
      } else {
        state.productslist = data;
      }
      state.page = pagination?.page;
      state.totalPages = pagination?.total_pages;
      state.limit = pagination?.limit;
      state.totalProducts = pagination?.total;
    },
    getallproductsfailure(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    getsingleproductStart(state, action) {
      state.isLoading = true;
      state.error = null;
    },
    getsingleproductSuccess(state, action) {
      state.isLoading = false;
      state.product = action.payload?.data;
    },
    getsingleproductfailure(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    getproductbannerStart(state, action) {
      state.isLoading = true;
      state.error = false;
    },
    getproductbannerSuccess(state, action) {
      state.isLoading = false;
      state.productbanner = action.payload;
    },
    getproductbannerfailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getallproductCategoryStart(state) {
      state.isLoading = true;
      state.error = null;
      state.productCategoryList = [];
    },
    getallproductCategorySuccess(state, action) {
      state.isLoading = false;
      state.productCategoryList = action.payload;
    },
    getallproductCategoryfailure(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    getallproductInventoryStart(state) {
      state.isInventoryLoading = true;
      state.error = null;
      state.productInventoryList = [];
    },
    getallproductInventorySuccess(state, action) {
      state.isInventoryLoading = false;
      state.productInventoryList = action.payload;
    },
    getallproductInventoryfailure(state, action) {
      state.error = action.payload;
      state.isInventoryLoading = false;
    },
    getproductInventoryStart(state) {
      state.isInventoryLoading = true;
      state.error = null;
      state.productInventory = null;
    },
    getproductInventorySuccess(state, action) {
      state.isInventoryLoading = false;
      state.productInventory = action.payload;
    },
    getproductInventoryfailure(state, action) {
      state.error = action.payload;
      state.isInventoryLoading = false;
    },

    filtersUpdate(state, action) {
      const { categoryId, sort, contentType, text } = action.payload;
      if (categoryId !== undefined) {
        state.Filters.categoryId = categoryId;
      }

      if (sort !== undefined) {
        state.Filters.sort = sort;
      }
      if (contentType !== undefined) {
        state.Filters.contentType = contentType;
      }
      if (text !== undefined) {
        state.Filters.text = text;
      }
    },

    getCartDataStart(state, action) {
      state.cartLoading = true;
      state.carterror = null;
      state.cart = [];
    },
    getCartDataSuccess(state, action) {
      state.cartLoading = false;
      state.cart = action.payload;
    },
    getCartDataFailure(state, action) {
      state.carterror = action.payload;
      state.cartLoading = false;
    },
    getWishlistDataStart(state, action) {
      state.wishlistLoading = true;
      state.wishlisterror = null;
      state.wishlist = [];
    },
    getWishlistDataSuccess(state, action) {
      state.wishlistLoading = false;
      state.wishlist = action.payload?.wishlist;
    },
    getWishlistDataFailure(state, action) {
      state.wishlisterror = action.payload;
      state.wishlistLoading = false;
    },
    getCartCountStart(state, action) {
      state.cartCount = 0;
      state.wishlistCount = 0;
    },
    getCartCountSuccess(state, action) {
      state.cartCount = action.payload.cart_length;
      state.wishlistCount = action.payload.wishlist_length;
    },
    getCartCountFailure(state, action) {
      state.cartCount = 0;
      state.wishlistCount = 0;
    },
  },
});

export const {
  getCartCountStart,
  getCartCountSuccess,
  getCartCountFailure,
  getallproductsStart,
  getallproductsSuccess,
  filtersUpdate,
  getallproductsfailure,
  getsingleproductStart,
  getsingleproductSuccess,
  getsingleproductfailure,
  getproductbannerStart,
  getproductbannerSuccess,
  getproductbannerfailure,
  getallproductCategoryStart,
  getallproductCategorySuccess,
  getallproductCategoryfailure,
  getallproductInventoryStart,
  getallproductInventorySuccess,
  getproductInventoryfailure,
  getproductInventoryStart,
  getproductInventorySuccess,
  getallproductInventoryfailure,
  getCartDataStart,
  getCartDataSuccess,
  getCartDataFailure,
  getWishlistDataStart,
  getWishlistDataSuccess,
  getWishlistDataFailure,
} = productsSlice.actions;

export default productsSlice.reducer;
